import React from 'react';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import './CompinedStyle.less';

const renderField = ({ input, label, type, disabled, meta: { touched, error } }) =>  //eslint-disable-line react/prop-types
   (
      <FormGroup>
         {label && <ControlLabel>{label}</ControlLabel>}
         <FormControl
            disabled={disabled}
            type={type}
            placeholder={label}
            {...input}
         />
         {touched && error && <span
            className="input-validation-error"
         >{error}</span>}
      </FormGroup>
   );

export default renderField;



/** WEBPACK FOOTER **
 ** ./src/components/FormTemplate/InputControl.js
 **/